import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delimiter, NOT_AVAILABLE } from '../../../common/constants';

@Component({
  selector: 'ui-info-field-item-value-list',
  templateUrl: './info-field-item-value-list.component.html',
  styleUrls: ['./info-field-item-value-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoFieldItemValueListComponent {
  @Input() label: string;
  @Input() items: string[];

  delimiter = Delimiter;
  notAvailable = NOT_AVAILABLE;
}
